module.exports = __webpack_public_path__ + "img/admissionicn.d20c4ab5.svg";